import { useDefaultModuleActions } from "../../common"
import { DynamoUserApi } from "../../../services"
import { TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { useSystemStateHooks } from "../../system"
import { dedupe } from "../../../utils/listUtils"
import { Ticket } from "../state/types"

export const useTicketActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const defaultModuleActions = useDefaultModuleActions()

    return (paramCompanyId?: string) => {
        const companyId = paramCompanyId || stateCompanyId
        const { fetchAll, fetchByIds } = defaultModuleActions(DynamoUserApi, define(companyId))

        const fetchAllTickets = async () => {
            return fetchAll(TableName.TICKETS) as Promise<Ticket[]>
        }

        const fetchTickets = (ids: string[]) => {
            return fetchByIds(TableName.TICKETS, ids)
        }

        const countTickets = async (taxCodeValue: string) => {
            const tickets = await fetchAllTickets()
            const taxCodes = tickets.flatMap(ticket => ticket.taxItems.map(taxItem => taxItem.taxCode))
            return dedupe(taxCodes).filter(taxCode => taxCode === taxCodeValue).length
        }

        return {
            fetchTickets,
            countTickets
        }
    }
}
